export default __webpack_public_path__ + "static/us-consumer-reviews-teaser-mobile-e0e3144c5d6da542a7803d7b90608a3d.png";